import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { PageHeader } from "@/components/PageHeader";
import { Loader2, BarChart3 } from "lucide-react";
import { BarChart, Bar, XAxis, YAxis, ResponsiveContainer, Cell, Tooltip } from "recharts";

const COLORS = ["#284b3e", "#BE5A45", "#D49A36", "#249c3d", "#56655F", "#ca244d"];
const TITLES = {
  inquiries_by_status: "Inquiries by Status", referrals_by_status: "Referrals by Status",
  applicants_by_status: "Applicants by Status", trips_by_status: "Trips by Status",
  vehicles_by_status: "Vehicles by Status", media_by_category: "Media by Category",
  media_by_status: "Media by Status",
};

function ChartCard({ title, data }) {
  const rows = Object.entries(data || {}).map(([name, value]) => ({ name: name.replace(/_/g, " "), value }));
  return (
    <div className="border border-border rounded-lg bg-card p-5">
      <h3 className="font-heading font-semibold mb-4 text-sm">{title}</h3>
      {rows.length === 0 ? <p className="text-sm text-muted-foreground py-8 text-center">No data.</p> : (
        <ResponsiveContainer width="100%" height={200}>
          <BarChart data={rows} layout="vertical" margin={{ left: 10, right: 20 }}>
            <XAxis type="number" hide />
            <YAxis type="category" dataKey="name" width={110} tick={{ fontSize: 12, fill: "#56655F" }} axisLine={false} tickLine={false} />
            <Tooltip cursor={{ fill: "rgba(40,75,62,0.06)" }} />
            <Bar dataKey="value" radius={[0, 4, 4, 0]} barSize={18}>
              {rows.map((r, i) => <Cell key={r.name} fill={COLORS[i % COLORS.length]} />)}
            </Bar>
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  );
}

export default function Reports() {
  const [data, setData] = useState(null);
  useEffect(() => { api.get("/reports/summary").then((r) => setData(r.data)).catch(() => setData({})); }, []);
  if (!data) return <div className="py-20 flex justify-center"><Loader2 className="w-6 h-6 animate-spin text-primary" /></div>;

  return (
    <div data-testid="reports-page">
      <PageHeader title="Reports & Analytics" subtitle="Operational insights across care, recruitment and fleet." />
      <div className="grid md:grid-cols-2 gap-5">
        {Object.entries(TITLES).map(([k, t]) => <ChartCard key={k} title={t} data={data[k]} />)}
      </div>
    </div>
  );
}
